import { getRequest, postRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';
import createUrlBuilder from 'utilities/url.builder.utils';

export const getEssentials = async () => {
  const urlBuilder = createUrlBuilder(`onecall/essentials`).toString();

  return await getRequest(LocateService, urlBuilder);
};

export const getAuthorities = async (id: string) => {
  const data = {
    workingOnBehalfOfID: id
  };
  const urlBuilder = createUrlBuilder(`onecall/authorities`).toString();

  return await postRequest(LocateService, urlBuilder, data);
};

export const createEnquiry = async (data: any) => {
  const urlBuilder = createUrlBuilder(`onecall/enquiries`).toString();

  return await postRequest(LocateService, urlBuilder, data);
};
